import ReportsTypes from './Reports.types';

export const reportsStart = (data: any) => ({
	type: ReportsTypes.REPORT_START,
	payload: data,
});

export const reportsSuccess = (data: any) => ({
	type: ReportsTypes.REPORT_SUCCESS,
	payload: data,
});

export const reportsFailure = (error: unknown) => ({
	type: ReportsTypes.REPORT_FAILURE,
	payload: error,
});

export const reportsResponseChanged = () => ({
	type: ReportsTypes.REPORT_RESPONSE_CHANGED,
});

export const reportsResponseRestStart = () => ({
	type: ReportsTypes.REPORT_RESPONSE_REST_START,
});
